import { render, staticRenderFns } from "./SubRegions.vue?vue&type=template&id=7059984f&scoped=true"
import script from "./SubRegions.vue?vue&type=script&lang=js"
export * from "./SubRegions.vue?vue&type=script&lang=js"
import style0 from "./SubRegions.vue?vue&type=style&index=0&id=7059984f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7059984f",
  null
  
)

export default component.exports